import { Col, Form, Row, Select } from "antd";
import React, { useMemo } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";

export const efficiency = {
  EFFICIENCY: {
    value: "EFFICIENCY",
    name: "Efficiency",
    formula: `(( 4 * sThreePointersMade) + (3 * sTwoPointersMade) + (2 * sFreeThrowsMade)) - (sThreePointersAttempted + sTwoPointersAttempted + sFreeThrowsAttempted) + sReboundsOffensive + sReboundsDefensive + sBlocks + sAssists + sSteals - sTurnovers`,
  },
  INDEX_OF_SUCCESS: {
    value: "INDEX_OF_SUCCESS",
    name: "Index Of Success",
    formula: `(sPoints + sReboundsTotal + sAssists + sSteals + sFoulsOn + sBlocks ) - ((sTwoPointersAttempted - sTwoPointersMade) + (sThreePointersAttempted - sThreePointersMade) + (sFreeThrowsAttempted - sFreeThrowsMade) + sTurnovers + sFoulsPersonal + sFoulsTechnical + sBlocksReceived))`,
  },
  PERFORMANCE_INDEX_RATING: {
    value: "PERFORMANCE_INDEX_RATING",
    name: "Performance Index Rating",
    formula: `((sPoints || 0)  + (sReboundsOffensive || 0) + (sReboundsDefensive || 0 )  + (sAssists || 0)  + ( sSteals || 0)  + (sBlocks || 0)  + (sFoulsOn || 0)) - ((sFieldGoalsMissed || 0)  + (sFreeThrowsMissed || 0)  + (sTurnovers || 0)  + ( sBlocks || 0)  + (sFoulsPersonal || 0))`,
  },
};

const effOptions = [
  {
    value: "EFFICIENCY",
    label: "Efficiency",
    formula: efficiency.EFFICIENCY.formula,
  },
  {
    value: "INDEX_OF_SUCCESS",
    label: "Index Of Success",
    formula: efficiency.INDEX_OF_SUCCESS.formula,
  },
  {
    value: "PERFORMANCE_INDEX_RATING",
    label: "Performance Index Rating",
    formula: efficiency.PERFORMANCE_INDEX_RATING.formula,
  },
];

const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 300px;
`;

const Label = styled.div`
  font-weight: bold;
`;

const Formula = styled.div`
  font-weight: normal;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const { Option } = Select;

const EfficiencyCalculationSelect = ({ form }) => {
  const { formatMessage } = useIntl();
  const selectedValue = Form.useWatch("efficiencyType") || efficiency.EFFICIENCY.value;

  const handleSelectChange = (value) => {
    form.setFieldsValue({ efficiencyType: value });
  };

  const selectedOption = useMemo(() => {
    return effOptions.find((item) => item.value === selectedValue);
  }, [selectedValue]);

  return (
    <Container>
      <Form.Item
        style={{ marginBottom: 0 }}
        name={"efficiencyType"}
        initialValue={selectedValue}
        label={formatMessage({
          id: "efficiencyType",
          defaultMessage: "Efficiency formula",
        })}
        tooltip={formatMessage({
          id: "form.help.match.profile.efficiency.type",
          defaultMessage: "Efficiency calculation used in Boxscore report only",
        })}
      >
        <Row justify="space-between">
          <Col span={23}>
            <Select
              optionLabelProp="label"
              popupMatchSelectWidth={false}
              onSelect={handleSelectChange}
              value={selectedValue}
            >
              {effOptions.map((item) => {
                return (
                  <Option key={item.value} value={item.value} label={item.label}>
                    <OptionContainer>
                      <Label>{item.label}</Label>
                      <Formula>{item.formula}</Formula>
                    </OptionContainer>
                  </Option>
                );
              })}
            </Select>
          </Col>
        </Row>
      </Form.Item>
      {selectedOption && selectedOption.value && (
        <div style={{ marginLeft: "auto", marginRight: 20 }}>
          <span>Formula</span>: <span style={{ fontSize: 14 }}>{selectedOption.formula}</span>
        </div>
      )}
    </Container>
  );
};

export default EfficiencyCalculationSelect;
